/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".legal-note[_ngcontent-%COMP%]{color:red;font-style:italic}a[_ngcontent-%COMP%]{color:#000;text-decoration:underline}"];
export { styles as styles };
